import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import { getUserSession } from "../../../../core/util/core/Session";
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import sleep from "sleep-promise";

function Form() {
    const session = getUserSession()
    
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [form, setForm] = useState();
    const { id } = useParams();
    
    const hiddenValues = {}

    if (session.loggedUserInfo.pdc_company_id) {
        hiddenValues.pdc_company_id = session.loggedUserInfo.pdc_company_id
    }

    const path = '/suppliers/';
    const paths = {
        endpointSave: config.endpoints.backend + 'suppliers/save',
        endpointGetById: config.endpoints.backend + 'suppliers/getById',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Fornecedor",
        labelTitleEdit: "Editar Fornecedor",
        labelTitleView: 'Visualizar Fornecedor'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                {
                    name: 'people_type',
                    type: 'select',
                    options: [
                        { label: 'Juridica', value: 'J' },
                        { label: 'Física', value: 'F' }
                    ],
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        setForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    label: 'Tipo de Cliente',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },        
                values.people_type === 'F' && {
                    name: 'cpf',
                    type: 'CPF',
                    label: 'CPF',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },          
                values.people_type === 'F' && {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },          
                values.people_type === 'J' && {
                    name: 'cnpj',
                    type: 'CNPJ',
                    label: 'CNPJ',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },          
                values.people_type === 'J' && {
                    name: 'corporate_name',
                    type: 'text',
                    label: 'Razão social',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                values.people_type === 'J' && {
                    name: 'fantasy_name',
                    type: 'text',
                    label: 'Nome fantasia',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                values.people_type === 'J' && {
                    name: 'estadual_registration',
                    type: 'text',
                    mask: '999.999.999.999',
                    label: 'Inscrição Estadual',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        {label:'Ativo',value:'1'},
                        {label:'Inativo',value:'0'}
                    ],
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
